import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParagraphComponent } from './paragraph/paragraph.component';
import { SkeletonCommonModule } from '../../common/components/common.module';

@NgModule({
  declarations: [ParagraphComponent],
  imports: [CommonModule, SkeletonCommonModule],
  exports: [ParagraphComponent]
})
export class ParagraphModule {}
